/**
 * KARVA Konfigurator in zwei Schritten (2026-10)
 *
 * Schritt 0  Noch kein Foto: rechts nur Schrittanzeige und Hinweis, links der Upload.
 * Schritt 1  "Dein Bild": Ansicht, Größe (Standardgrößen oder Wunschformat), Optimierung, Preis, "Weiter".
 * Schritt 2  "Extras": Wandhalterung, Erinnerungsset, Express, Geschenkverpackung, Gravur hinten/vorne,
 *            Summe, "Zurück" und "In den Warenkorb".
 *
 * Die Boxen selbst bauen karva-configurator-extras.js, karva-gift.js und karva-paket.js wie bisher.
 * Dieses Skript sortiert sie nur in den zweiten Schritt und blendet je Schritt ein und aus.
 * Die Frage "Ihr dürft mich fragen" wird ausgeblendet (wird nach dem Versand per E-Mail gestellt).
 */
(function () {
  'use strict';

  var ORDER = ['karva-paket-note', 'karva-mount', 'karva-set', 'karva-stand', 'karva-express', 'karva-gift', 'karva-engrave', 'karva-front'];
  var POPULAR_AREA = 2400;   // 60 × 40 cm als Vorauswahl
  var right = null, step2 = null, current = 1;

  function byId(id) { return document.getElementById(id); }
  function hasImage() { return !!document.querySelector('.halftone-image-placeholder.has-image'); }
  function euro(n) { return n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function parseEuro(t) {
    var m = String(t || '').replace(/\s/g, ' ').match(/(\d{1,3}(?:\.\d{3})*,\d{2}|\d+(?:,\d{2})?)\s*€/);
    return m ? parseFloat(m[1].replace(/\./g, '').replace(',', '.')) : 0;
  }

  function injectStyles() {
    if (byId('kv-steps-style')) return;
    var st = document.createElement('style');
    st.id = 'kv-steps-style';
    st.textContent = [
      '#karva-social-box{display:none!important}',
      '.halftone-right-section[data-kv="0"]>*:not(#kv-stepper):not(#kv-intro){display:none!important}',
      '.halftone-right-section:not([data-kv="0"])>#kv-intro{display:none!important}',
      '.halftone-right-section[data-kv="1"]>#kv-step2,.halftone-right-section[data-kv="1"]>.halftone-action-row,' +
        '.halftone-right-section[data-kv="1"]>#kv-nav2,.halftone-right-section[data-kv="1"]>label.karva-gift,' +
        '.halftone-right-section[data-kv="1"]>label.karva-mount,.halftone-right-section[data-kv="1"]>#karva-paket-note{display:none!important}',
      '.halftone-right-section[data-kv="2"]>#karva-view-toggle,.halftone-right-section[data-kv="2"]>.halftone-module,' +
        '.halftone-right-section[data-kv="2"]>label.kv-opt,.halftone-right-section[data-kv="2"]>.halftone-pricing-section,' +
        '.halftone-right-section[data-kv="2"]>#kv-nav1,.halftone-right-section[data-kv="2"]>#karva-help,' +
        '.halftone-right-section[data-kv="2"]>.halftone-sliders-row{display:none!important}',
      '#kv-stepper{display:flex;gap:6px;margin:0 0 16px;padding:0 0 12px;border-bottom:1px solid #e3ded4;}',
      '#kv-stepper button{flex:1 1 0;display:flex;align-items:center;gap:8px;padding:6px 4px;border:0;background:none;font:inherit;font-size:14px;font-weight:600;color:#A8A39A;cursor:pointer;text-align:left;}',
      '#kv-stepper button span{display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;border-radius:50%;border:1.5px solid currentColor;font-size:12px;}',
      '#kv-stepper button.is-active{color:#202020;}',
      '#kv-stepper button.is-active span{background:#202020;border-color:#202020;color:#fff;}',
      '#kv-stepper button[disabled]{cursor:default;}',
      '#kv-intro{font-size:15px;line-height:1.6;color:#202020;}',
      '#kv-intro ol{margin:8px 0 0;padding-left:20px;color:#555;font-size:14px;}',
      '.halftone-right-section>#kv-stepper,.halftone-right-section>#kv-intro,.halftone-right-section>#kv-nav1,.halftone-right-section>#kv-nav2,.halftone-right-section>#kv-step2{align-self:stretch!important;width:100%!important;box-sizing:border-box;}',
      '.kv-btn{display:block;width:100%;height:52px;padding:0 18px;border:0;border-radius:var(--radius-button,4px);background:var(--color-accent,#DFB773);color:#202020;font:inherit;font-size:15px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;cursor:pointer;}',
      '.kv-btn:hover{opacity:.9;}',
      /* Akkordeon im Schritt 2 */
      '#kv-extras{display:flex;flex-direction:column;gap:10px;}',
      '.kv-acc{border:1px solid #e3ded4!important;border-radius:6px;background:#fff;overflow:hidden;}',
      '.kv-acc.is-on{border-color:#202020!important;}',
      '#kv-extras .kv-acc__head{display:flex!important;align-items:center;gap:12px;width:100%;min-height:64px;box-sizing:border-box;padding:12px 16px!important;margin:0!important;cursor:pointer;color:#202020;-webkit-tap-highlight-color:transparent;}',
      '#kv-extras .kv-acc__box{flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;box-sizing:border-box;border:2px solid #202020;border-radius:4px;background:#fff;color:#fff;font-size:15px;line-height:1;cursor:pointer;}',
      '#kv-extras .kv-acc.is-on .kv-acc__box{background:#202020;}',
      '#kv-extras .kv-acc__title{flex:1 1 auto;min-width:0;font-size:15px;font-weight:600;line-height:1.3;}',
      '#kv-extras .kv-acc__price{flex:0 0 auto;font-size:14px;color:#555;white-space:nowrap;}',
      '#kv-extras .kv-acc__price .karva-gift__badge{display:none;}',
      '#kv-extras .kv-acc__chev{flex:0 0 auto;width:9px;height:9px;border-right:2px solid #202020;border-bottom:2px solid #202020;transform:rotate(45deg);margin:-5px 2px 0 4px;transition:transform .2s;}',
      '#kv-extras .kv-acc.is-open .kv-acc__chev{transform:rotate(-135deg);margin-top:5px;}',
      '#kv-extras .kv-acc__body{display:none;padding:0 16px 16px 54px;}',
      '#kv-extras .kv-acc.is-open .kv-acc__body{display:block;}',
      '#kv-extras .kv-acc__body>label{display:block!important;border:0!important;padding:0!important;margin:0!important;background:none!important;box-shadow:none!important;cursor:default!important;}',
      '#kv-extras .kv-acc__body>label>input[type=checkbox]{position:absolute!important;opacity:0!important;width:1px!important;height:1px!important;pointer-events:none;}',
      '#kv-extras .kv-acc__body>label>span{display:block!important;}',
      '#kv-extras .kv-acc__body>label>span>strong{display:none!important;}',
      '#kv-extras .kv-acc__body small{display:block;font-size:13px;line-height:1.5;color:#555;margin:0;}',
      '#kv-extras .kv-acc__img{display:block;width:88px!important;height:88px!important;max-width:none;object-fit:cover;border-radius:4px;margin:10px 0 0;background:#F3F1EC;}',
      '#kv-extras .karva-gift__fields{margin-top:12px;}',
      /* Mobile: feste Leiste unten mit Weiter bzw. Warenkorb */
      '#kv-bar{display:none;}',
      '@media (max-width:768px){' +
        '.halftone-right-section[data-kv="1"]~#kv-bar,.halftone-right-section[data-kv="2"]~#kv-bar{display:flex;}' +
        '#kv-bar{position:fixed;left:0;right:0;bottom:0;z-index:10000;align-items:center;gap:14px;padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -2px 12px rgba(0,0,0,.12);}' +
        '#kv-bar .kv-bar__price{flex:0 0 auto;font-size:18px;font-weight:700;color:#202020;}' +
        '#kv-bar .kv-btn{flex:1 1 auto;}' +
        '.halftone-right-section[data-kv="1"]>#kv-nav1,.halftone-right-section[data-kv="2"]>.halftone-action-row{display:none!important;}' +
        '.halftone-right-section:not([data-kv="0"]){padding-bottom:96px!important;}' +
        '.karva-view-toggle{width:100%!important;max-width:100%;box-sizing:border-box;}' +
        '.karva-view-toggle button{flex:1 1 0;min-width:0;padding:9px 4px!important;font-size:12px!important;line-height:1.25;white-space:normal;}' +
      '}',
      '.kv-back{display:inline-block;margin:0 0 14px;padding:4px 0;border:0;background:none;font:inherit;font-size:14px;font-weight:600;color:#202020;cursor:pointer;text-decoration:underline;}',
      '#kv-nav1{margin:14px 0 0;}',
      '#kv-step2 h3{margin:0 0 4px;font-size:20px;}',
      '#kv-step2 .kv-sub{margin:0 0 14px;font-size:14px;color:#555;}',
      '#kv-sum{margin:16px 0 12px;padding:14px 0 0;border-top:1px solid #e3ded4;font-size:14px;color:#555;}',
      '#kv-sum .kv-row{display:flex;justify-content:space-between;gap:12px;margin:0 0 4px;}',
      '#kv-sum .kv-total{font-size:22px;font-weight:700;color:#202020;margin-top:6px;}',
      '#kv-sum .kv-note{margin-top:4px;font-size:12px;}',
      /* Größe: Eingabefelder nur bei Wunschformat oder "Eigene Größe" */
      '.halftone-module.kv-has-presets .halftone-size-inputs-with-lock{max-height:0;overflow:hidden;opacity:0;margin:0!important;transition:max-height .3s ease,opacity .2s ease,margin .3s ease;}',
      '.halftone-module.kv-has-presets.kv-custom-open .halftone-size-inputs-with-lock{max-height:220px;opacity:1;margin:4px 0 0!important;}',
      '.karva-size-custom::after{content:"";display:inline-block;width:7px;height:7px;margin:0 2px 2px 10px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);transition:transform .2s;vertical-align:middle;}',
      '.halftone-module.kv-custom-open .karva-size-custom::after{transform:rotate(-135deg);margin-bottom:-2px;}',
      '.karva-size-custom{padding:10px 14px!important;}',
      '.halftone-module.kv-has-presets .halftone-module-size-legend{display:none}',
      '.karva-size-custom{padding:8px 12px;border:1px dashed #A8A39A;border-radius:4px;background:none;font:inherit;font-size:13px;color:#202020;cursor:pointer;}',
      '.karva-size-custom.is-active,.halftone-module.kv-custom-open .karva-size-custom{border-style:solid;border-color:#202020;}',
      '.karva-size-wunsch{margin:0;font-size:13px;line-height:1.5;color:#555;}',
      '.karva-size-wunsch strong{display:block;font-size:14px;color:#202020;margin-bottom:2px;}'
    ].join('\n');
    document.head.appendChild(st);
  }

  function boxFor(id) {
    var el = byId(id);
    if (!el) return null;
    if (id === 'karva-paket-note') return el;
    return el.closest('label') || el;
  }

  function build() {
    right = document.querySelector('.halftone-right-section');
    var pricing = document.querySelector('.halftone-pricing-section');
    var action = document.querySelector('.halftone-action-row');
    if (!right || !pricing || !action) return false;
    if (byId('kv-stepper')) return true;
    injectStyles();

    var stepper = document.createElement('div');
    stepper.id = 'kv-stepper';
    stepper.innerHTML = '<button type="button" data-kv-go="1" class="is-active"><span>1</span>Dein Bild</button>' +
      '<button type="button" data-kv-go="2"><span>2</span>Extras</button>';
    right.insertBefore(stepper, right.firstChild);

    var intro = document.createElement('div');
    intro.id = 'kv-intro';
    intro.innerHTML = '<p style="margin:0;"><strong>Lade zuerst dein Foto hoch.</strong></p>' +
      '<ol><li>Foto hochladen und Vorschau ansehen</li><li>Größe wählen</li><li>Extras wie Gravur oder Geschenkverpackung dazu, wenn du magst</li></ol>';
    stepper.parentNode.insertBefore(intro, stepper.nextSibling);

    var nav1 = document.createElement('div');
    nav1.id = 'kv-nav1';
    nav1.innerHTML = '<button type="button" class="kv-btn" data-kv-go="2">Weiter zu den Extras</button>';
    pricing.parentNode.insertBefore(nav1, pricing.nextSibling);

    step2 = document.createElement('div');
    step2.id = 'kv-step2';
    step2.innerHTML = '<h3>Extras für dein Bild</h3><p class="kv-sub">Alles optional. Wenn du nichts dazu möchtest, leg dein Bild einfach in den Warenkorb.</p>' +
      '<div id="kv-extras"></div><div id="kv-sum"></div>';
    action.parentNode.insertBefore(step2, action);

    var nav2 = document.createElement('div');
    nav2.id = 'kv-nav2';
    nav2.innerHTML = '<button type="button" class="kv-back" data-kv-go="1">← Zurück zu deinem Bild</button>';
    step2.parentNode.insertBefore(nav2, step2);

    var bar = document.createElement('div');
    bar.id = 'kv-bar';
    bar.innerHTML = '<span class="kv-bar__price"></span><button type="button" class="kv-btn" data-kv-bar>Weiter zu den Extras</button>';
    right.parentNode.insertBefore(bar, right.nextSibling);
    bar.querySelector('[data-kv-bar]').addEventListener('click', function (e) {
      e.preventDefault();
      if (current === 1) { go(2); return; }
      var cart = byId('custom_add_cart');
      if (cart && !cart.disabled) cart.click();
    });

    document.addEventListener('click', function (e) {
      var bx = e.target && e.target.closest ? e.target.closest('.kv-acc__box') : null;
      if (bx) {
        e.preventDefault(); e.stopPropagation();
        var acc = bx.closest('.kv-acc'), real = acc && acc.querySelector('.kv-acc__body input[type=checkbox]');
        if (real) { real.checked = !real.checked; real.dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
      var h = e.target && e.target.closest ? e.target.closest('.kv-acc__head') : null;
      if (h) { e.preventDefault(); openOnly(h.parentNode, !h.parentNode.classList.contains('is-open')); return; }
      // Klick auf Beschreibung oder Bild im aufgeklappten Bereich soll das Häkchen nicht umschalten
      var inBody = e.target && e.target.closest ? e.target.closest('.kv-acc__body>label') : null;
      if (inBody && !(e.target.closest('input,textarea,select,a'))) { e.preventDefault(); return; }
      var t = e.target && e.target.closest ? e.target.closest('[data-kv-go]') : null;
      if (!t) return;
      e.preventDefault();
      go(parseInt(t.getAttribute('data-kv-go'), 10));
    });
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.closest && e.target.closest('#kv-extras') || e.target.id === 'custom-quantity')) renderSum();
    });
    return true;
  }

  function go(n) {
    if (!right) return;
    if (n === 2 && !hasImage()) n = 1;
    current = n;
    apply();
    var top = byId('kv-stepper');
    if (top) {
      right.scrollTop = 0;
      var r = top.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function placeInputs() {
    var box = byId('karva-size-presets'), inp = document.querySelector('.halftone-size-inputs-with-lock');
    if (box && inp && box.nextElementSibling !== inp && box.parentNode) box.parentNode.insertBefore(inp, box.nextSibling);
  }

  function apply() {
    placeInputs();
    var help = byId('karva-help');
    if (help && current === 1) help.style.setProperty('margin-top', '16px', 'important');
    var state = hasImage() ? String(current) : '0';
    if (right.getAttribute('data-kv') !== state) right.setAttribute('data-kv', state);
    var btns = document.querySelectorAll('#kv-stepper [data-kv-go]');
    for (var i = 0; i < btns.length; i++) {
      var n = parseInt(btns[i].getAttribute('data-kv-go'), 10);
      btns[i].classList.toggle('is-active', state !== '0' ? n === current : n === 1);
      btns[i].disabled = state === '0' && n === 2;
    }
    if (state === '2') renderSum();
    renderBar();
  }

  var IMG = 'https://cdn.shopify.com/s/files/1/0729/0391/7848/';
  var IMAGES = {
    'karva-mount': IMG + 'products/7951861_01_Dibond_Spiegelaufh-ngeset-A-3kg.jpg?v=1691584819&width=700',
    'karva-set': IMG + 'files/9TF9447_inPixio.jpg?v=1691274151&width=700',
    'karva-stand': IMG + 'files/9TF9287_inPixio.jpg?v=1691794956&width=700',
    'karva-express': IMG + 'files/DSC08393_9224ddb3-164d-4fd3-bb38-4866d758490e.jpg?v=1791386419&width=700',
    'karva-gift': IMG + 'files/karva-geschenkverpackung.jpg?v=1791316169&width=700',
    'karva-engrave': IMG + 'files/karva-gravur-rueckseite.jpg?v=1791316169&width=700',
    'karva-front': IMG + 'files/DSC08219_74badf9e-bb21-4ea3-9ff6-eaa530b6f692.jpg?v=1773866412&width=700'
  };

  /* Immer nur eine Kachel offen; die geöffnete bei Bedarf sanft ins Bild holen */
  function openOnly(acc, open) {
    var all = document.querySelectorAll('#kv-extras .kv-acc');
    for (var i = 0; i < all.length; i++) if (all[i] !== acc) all[i].classList.remove('is-open');
    acc.classList.toggle('is-open', open);
    if (!open) return;
    setTimeout(function () {
      var r = acc.getBoundingClientRect(), barH = (byId('kv-bar') && byId('kv-bar').offsetHeight) || 0;
      if (r.top < 0 || r.bottom > window.innerHeight - barH) acc.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 50);
  }

  function wrapperFor(id) { return byId('kvw-' + id); }

  function makeWrapper(id, box) {
    var w = document.createElement('div');
    w.className = 'kv-acc';
    w.id = 'kvw-' + id;
    w.innerHTML = '<div class="kv-acc__head" role="button" tabindex="0" aria-expanded="false">' +
      '<span class="kv-acc__box" role="checkbox" aria-checked="false" tabindex="0" aria-label="Auswählen">✓</span><span class="kv-acc__title"></span>' +
      '<span class="kv-acc__price"></span><span class="kv-acc__chev" aria-hidden="true"></span></div>' +
      '<div class="kv-acc__body"></div>';
    var cb = box.querySelector('input[type=checkbox]');
    var small = box.querySelector('small');
    if (IMAGES[id] && !box.querySelector('.kv-acc__img')) {
      var im = document.createElement('img');
      im.className = 'kv-acc__img'; im.loading = 'lazy'; im.alt = ''; im.src = IMAGES[id];
      if (small && small.parentNode) small.parentNode.insertBefore(im, small.nextSibling);
    }
    // Bei Auswahl aufklappen, wenn es etwas einzugeben gibt (Gravur, Gruß, Trauerkarte)
    if (cb && box.querySelector('input[type=text],textarea,select')) {
      cb.addEventListener('change', function () { if (cb.checked) openOnly(w, true); });
    }
    w.querySelector('.kv-acc__body').appendChild(box);
    return w;
  }

  function updateHead(id) {
    var w = wrapperFor(id), box = boxFor(id);
    if (!w || !box) return;
    var strong = box.querySelector('strong');
    if (strong) {
      var html = strong.innerHTML, i = html.indexOf('('), j = html.lastIndexOf(')');
      var title = (i > -1 ? strong.textContent.slice(0, strong.textContent.indexOf('(')) : strong.textContent).trim().replace(/\s+dazu$/, '');
      var price = i > -1 && j > i ? html.slice(i + 1, j) : '';
      var t = w.querySelector('.kv-acc__title'), p = w.querySelector('.kv-acc__price');
      if (t.textContent !== title) t.textContent = title;
      if (p.innerHTML !== price) p.innerHTML = price;
    }
    var cb = box.querySelector('input[type=checkbox]');
    w.classList.toggle('is-on', !!(cb && cb.checked));
    var bxe = w.querySelector('.kv-acc__box');
    if (bxe) bxe.setAttribute('aria-checked', cb && cb.checked ? 'true' : 'false');
    w.querySelector('.kv-acc__head').setAttribute('aria-expanded', w.classList.contains('is-open') ? 'true' : 'false');
  }

  /* Boxen als Akkordeon in den zweiten Schritt sortieren (nur verschieben, wenn nötig, damit Eingaben erhalten bleiben) */
  function sortBoxes() {
    var list = byId('kv-extras');
    if (!list) return;
    var opt = byId('karva-optimize');
    if (opt && opt.closest('label')) opt.closest('label').classList.add('kv-opt');
    for (var i = 0; i < ORDER.length; i++) {
      var id = ORDER[i], box = boxFor(id);
      if (!box) continue;
      var node;
      if (id === 'karva-paket-note') {
        node = box;
      } else {
        node = wrapperFor(id);
        if (!node) node = makeWrapper(id, box);
        else if (box.parentNode !== node.querySelector('.kv-acc__body')) node.querySelector('.kv-acc__body').appendChild(box);
        updateHead(id);
      }
      if (node.parentNode === list) continue;
      var before = null;
      for (var k = i + 1; k < ORDER.length; k++) {
        var nb = ORDER[k] === 'karva-paket-note' ? byId('karva-paket-note') : wrapperFor(ORDER[k]);
        if (nb && nb.parentNode === list) { before = nb; break; }
      }
      list.insertBefore(node, before);
    }
  }

  function renderBar() {
    var bar = byId('kv-bar');
    if (!bar) return;
    var btn = bar.querySelector('[data-kv-bar]'), pr = bar.querySelector('.kv-bar__price');
    var cart = byId('custom_add_cart');
    var label = current === 1 ? 'Weiter zu den Extras' : (cart ? cart.textContent.trim() : 'In den Warenkorb');
    if (btn.textContent !== label) btn.textContent = label;
    btn.disabled = current === 2 && !!(cart && cart.disabled);
    var price = current === 1 ? (byId('halftone-price-display') || {}).textContent : (byId('kv-sum') ? (byId('kv-sum').querySelector('.kv-total span:last-child') || {}).textContent : '');
    price = (price || '').trim();
    if (pr.textContent !== price) pr.textContent = price;
  }

  function extraPrice(box) {
    var strong = box.querySelector('strong');
    var t = strong ? strong.textContent : '';
    if (/inklusive|gratis/i.test(t)) return 0;
    var sel = box.querySelector('select');
    if (sel && sel.options[sel.selectedIndex]) {
      var p = parseEuro(sel.options[sel.selectedIndex].textContent);
      if (p) return p;
    }
    var m = t.match(/\+\s*([\d.,]+)\s*€/);
    return m ? parseFloat(m[1].replace(/\./g, '').replace(',', '.')) : 0;
  }

  function renderSum() {
    var sum = byId('kv-sum'), list = byId('kv-extras');
    if (!sum || !list) return;
    var qty = parseInt((byId('custom-quantity') || {}).value, 10) || 1;
    var bild = parseEuro((byId('halftone-price-display') || {}).textContent);
    var extras = 0, names = [];
    var boxes = list.querySelectorAll('.kv-acc__body>label');
    for (var i = 0; i < boxes.length; i++) {
      var cb = boxes[i].querySelector('input[type=checkbox]');
      if (!cb || !cb.checked) continue;
      extras += extraPrice(boxes[i]);
      var s = boxes[i].querySelector('strong');
      if (s) names.push(s.textContent.replace(/\s*\(.*$/, '').trim());
    }
    var w = (byId('custom-width') || {}).value, h = (byId('custom-height') || {}).value;
    sum.innerHTML =
      '<div class="kv-row"><span>Dein Bild' + (w && h ? ' (' + String(w).replace('.', ',') + ' × ' + String(h).replace('.', ',') + ' cm)' : '') + '</span><span>' + euro(bild) + '</span></div>' +
      '<div class="kv-row"><span>' + (names.length ? 'Extras: ' + names.join(', ') : 'Keine Extras') + '</span><span>' + euro(extras) + '</span></div>' +
      (qty > 1 ? '<div class="kv-row"><span>Anzahl</span><span>× ' + qty + '</span></div>' : '') +
      '<div class="kv-row kv-total"><span>Gesamt</span><span>' + euro((bild + extras) * qty) + '</span></div>' +
      '<div class="kv-note">Inkl. MwSt., zzgl. Versandkosten</div>';
  }

  /* Nach dem Upload die beliebteste Standardgröße vorwählen (Pakete wählen ihre Größe selbst) */
  function defaultPreset() {
    var box = byId('karva-size-presets');
    if (!box || !hasImage()) return;
    var ratio = box.getAttribute('data-ratio');
    if (!ratio || box.getAttribute('data-kv-default') === ratio) return;
    var btns = box.querySelectorAll('.karva-size-preset');
    box.setAttribute('data-kv-default', ratio);
    if (!btns.length || box.querySelector('.karva-size-preset.is-active')) return;
    if (/[?&]paket=/.test(location.search)) return;
    var best = null, bestD = 1e12;
    for (var i = 0; i < btns.length; i++) {
      var a = parseFloat(btns[i].getAttribute('data-w')) * parseFloat(btns[i].getAttribute('data-h'));
      var d = Math.abs(a - POPULAR_AREA);
      if (d < bestD) { bestD = d; best = btns[i]; }
    }
    if (best) best.click();
  }

  var lastImage = false;
  function tick() {
    if (!build()) return;
    var img = hasImage();
    if (img && !lastImage) current = 1;      // neues Foto: immer bei Schritt 1 beginnen
    lastImage = img;
    sortBoxes();
    defaultPreset();
    apply();
  }

  function init() {
    tick();
    setInterval(tick, 400);
    var price = byId('halftone-price-display');
    if (price) new MutationObserver(function () { if (current === 2) renderSum(); })
      .observe(price, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
